(function () {
  const wishlistKey = 'cargrow-wishlist';

  const showReturnPageFallback = () => {
    if (!/\/pages\/politica-de-retur\/?$/.test(window.location.pathname)) return;
    const template = document.getElementById('cargrow-return-page-fallback');
    const missingPage = template && template.parentElement.querySelector('.template-404');
    if (!missingPage) return;
    missingPage.replaceWith(template.content.cloneNode(true));
    template.remove();
    document.title = 'Politica de retur – ' + document.title.split(' – ').pop();
  };

  const showWishlistPageFallback = () => {
    if (!/^\/pages\/(wishlist|favorite)\/?$/.test(window.location.pathname)) return;
    const missingPage = document.querySelector('main[data-template="404"] .template-404, .template-404');
    if (!missingPage) return;
    const page = document.createElement('section');
    page.className = 'page-width cargrow-page cargrow-page--wishlist cargrow-wishlist-fallback';
    page.innerHTML = `
      <section class="cargrow-page__hero cargrow-page__hero--wishlist" aria-labelledby="CargrowWishlistFallbackTitle">
        <div class="cargrow-page__hero-copy">
          <p class="cargrow-page__eyebrow">CarGrow · colecția ta</p>
          <h1 id="CargrowWishlistFallbackTitle" class="main-page-title page-title h0">Favoritele mele</h1>
          <p class="cargrow-page__hero-summary">Păstrează aproape aromele pe care vrei să le descoperi la următorul drum.</p>
          <span class="cargrow-wishlist-hero-mark" aria-hidden="true">♡</span>
        </div>
        <div class="cargrow-page__hero-media" aria-hidden="true"></div>
      </section>
      <section class="cargrow-wishlist-shell" aria-label="Produse favorite">
        <div class="cargrow-wishlist-shell__heading">
          <div>
            <p class="cargrow-about__kicker">Selecția ta personală</p>
            <h2>Alege în ritmul tău.</h2>
            <p>Compară favoritele și revino la ele când aroma potrivită devine clară.</p>
          </div>
          <a class="cargrow-text-link" href="/collections/all">Explorează toate aromele</a>
        </div>
        <div class="cargrow-wishlist-page" data-wishlist-page aria-live="polite"></div>
      </section>`;
    missingPage.replaceWith(page);
    document.title = 'Favoritele mele – ' + document.title.split(' – ').pop();
  };

  const readWishlist = () => {
    try {
      const items = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(items) ? items.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/products/')) : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try { localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (error) { return false; }
    return true;
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const money = (cents) => `${(Number(cents || 0) / 100).toFixed(2).replace('.', ',')} RON`;
  const normalizeImageUrl = (url) => (url && url.startsWith('//') ? `https:${url}` : url);

  const syncWishlistButtons = () => {
    const items = readWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach((bubble) => {
      bubble.replaceChildren();
      if (!items.length) return;
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      visible.textContent = items.length < 100 ? String(items.length) : '99+';
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = `${items.length} produse favorite`;
      bubble.append(visible, hidden);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.classList.toggle('is-saved', saved);
      const icon = button.querySelector('.cargrow-wishlist-button__icon, span');
      if (icon && button.classList.contains('cargrow-wishlist-button')) icon.textContent = saved ? '♥' : '♡';
    });
  };

  const renderWishlistPage = () => {
    const container = document.querySelector('[data-wishlist-page]');
    if (!container) return;
    const items = readWishlist();
    if (!items.length) {
      container.innerHTML = `
        <div class="cargrow-wishlist-empty">
          <span class="cargrow-wishlist-empty__icon" aria-hidden="true">♡</span>
          <div>
            <h3>Lista ta așteaptă prima aromă.</h3>
            <p>Apasă pe inimă lângă orice parfum și îl vei găsi aici când ești gata să alegi.</p>
          </div>
          <a class="button" href="/collections/all">Descoperă aromele</a>
        </div>`;
      return;
    }
    container.innerHTML = items.map((item) => `
      <article class="cargrow-wishlist-item">
        <a class="cargrow-wishlist-item__media" href="${escapeHtml(item.url)}">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="cargrow-wishlist-item__body">
          <p class="cargrow-wishlist-item__eyebrow">Parfum auto CarGrow</p>
          <h2><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h2>
          <p class="cargrow-wishlist-item__price">${escapeHtml(item.price || '')}</p>
          <div class="cargrow-wishlist-item__actions">
            <a class="button button--secondary" href="${escapeHtml(item.url)}">Vezi produsul</a>
            <button type="button" class="cargrow-wishlist-remove" data-wishlist-toggle data-product-handle="${escapeHtml(item.handle)}" data-product-url="${escapeHtml(item.url)}" data-product-title="${escapeHtml(item.title)}" aria-pressed="true">Elimină</button>
          </div>
        </div>
      </article>
    `).join('');
  };

  const quickView = document.querySelector('[data-quick-view]');
  const quickViewContent = quickView && quickView.querySelector('[data-quick-view-content]');

  const closeQuickView = () => {
    if (!quickView) return;
    quickView.hidden = true;
    quickView.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cargrow-quick-view-open');
  };

  const openQuickView = async (url) => {
    if (!quickView || !quickViewContent) return;
    quickView.hidden = false;
    quickView.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cargrow-quick-view-open');
    quickViewContent.innerHTML = '<div class="cargrow-quick-view__loading">Se încarcă aroma…</div>';
    try {
      const response = await fetch(`${url}.js`);
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      const variant = product.variants.find((item) => item.available) || product.variants[0];
      const image = normalizeImageUrl(product.featured_image || (product.images && product.images[0]));
      const description = (product.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      const hasDiscount = product.compare_at_price > product.price;
      quickViewContent.innerHTML = `
        <div class="cargrow-quick-view__media">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}">` : ''}</div>
        <div class="cargrow-quick-view__body">
          <p class="cargrow-quick-view__eyebrow">CarGrow · parfum auto</p>
          <h2>${escapeHtml(product.title)}</h2>
          <div class="cargrow-quick-view__price">${hasDiscount ? `<s>${money(product.compare_at_price)}</s>` : ''}<strong>${money(product.price)}</strong></div>
          ${description ? `<p class="cargrow-quick-view__description">${escapeHtml(description.slice(0, 220))}</p>` : ''}
          <div class="cargrow-quick-view__actions">
            <button type="button" class="button" data-quick-view-add data-variant-id="${escapeHtml(variant && variant.id)}" ${variant && variant.available ? '' : 'disabled'}>${variant && variant.available ? 'Adaugă în coș' : 'Indisponibil'}</button>
            <a class="button button--secondary" href="${escapeHtml(product.url || url)}">Detalii produs</a>
          </div>
        </div>`;
    } catch (error) {
      quickViewContent.innerHTML = '<p class="cargrow-quick-view__error">Nu am putut încărca produsul. Deschide pagina completă pentru detalii.</p>';
    }
  };


  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const items = readWishlist();
    const index = items.findIndex((item) => item.handle === button.dataset.productHandle);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push({
        handle: button.dataset.productHandle,
        url: button.dataset.productUrl,
        title: button.dataset.productTitle,
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
    }
    if (!writeWishlist(items)) {
      button.setAttribute('aria-label', 'Favoritele nu pot fi salvate. Permite stocarea locală în browser.');
      return;
    }
    syncWishlistButtons();
    renderWishlistPage();
  });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quick-view-trigger]');
    if (trigger) {
      event.preventDefault();
      openQuickView(trigger.dataset.productUrl);
      return;
    }
    if (event.target.closest('[data-quick-view-close], [data-quick-view-overlay]')) {
      closeQuickView();
      return;
    }
    const addButton = event.target.closest('[data-quick-view-add]');
    if (!addButton || !addButton.dataset.variantId) return;
    addButton.disabled = true;
    addButton.textContent = 'Se adaugă…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addButton.dataset.variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Cart error');
      addButton.textContent = 'Adăugat în coș';
      setTimeout(() => { window.location.href = '/cart'; }, 500);
    } catch (error) {
      addButton.disabled = false;
      addButton.textContent = 'Încearcă din nou';
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeQuickView();
  });

  const translateCookieBanner = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.cargrowTranslated === 'true') return;

    const title = banner.querySelector('#shopify-pc__banner__body-title');
    const paragraph = banner.querySelector('.shopify-pc__banner__body p');
    const policyLink = banner.querySelector('#shopify-pc__banner__body-policy-link');
    const manageButton = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    const acceptButton = banner.querySelector('#shopify-pc__banner__btn-accept');
    const declineButton = banner.querySelector('#shopify-pc__banner__btn-decline');

    if (title) title.textContent = 'Preferințe cookie';
    if (paragraph && policyLink) {
      paragraph.textContent =
        'Noi și partenerii noștri, inclusiv Shopify, folosim cookie-uri și tehnologii similare pentru personalizarea experienței, reclame și analiză. Le folosim în aceste scopuri doar dacă accepți. Află mai multe în ';
      policyLink.textContent = 'Politica de confidențialitate';
      paragraph.appendChild(policyLink);
    }

    if (manageButton) manageButton.textContent = 'Preferințe';
    if (acceptButton) acceptButton.textContent = 'Accept';
    if (declineButton) declineButton.textContent = 'Refuz';

    banner.dataset.cargrowTranslated = 'true';
  };

  document.addEventListener('DOMContentLoaded', translateCookieBanner);
  const bindCargrowMessagingForms = () => {
    document.querySelectorAll('[data-cargrow-newsletter-form], [data-cargrow-contact-form]').forEach((form) => {
      if (form.dataset.cargrowMessagingBound === 'true') return;
      const endpoint = form.dataset.cargrowMarketingEndpoint?.trim();
      if (!endpoint) return;
      form.dataset.cargrowMessagingBound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const submit = form.querySelector('button[type="submit"]');
        const email = form.querySelector('input[type="email"]')?.value?.trim() || '';
        const isContact = form.hasAttribute('data-cargrow-contact-form');
        const payload = isContact
          ? {
              name: form.querySelector('input[name*="name"]')?.value?.trim() || '',
              email,
              phone: form.querySelector('input[type="tel"]')?.value?.trim() || '',
              message: form.querySelector('textarea')?.value?.trim() || '',
            }
          : { email };
        const submitLabel = submit?.querySelector('[data-cargrow-submit-label]');
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          submit.classList.add('is-loading');
          if (submitLabel) {
            submitLabel.dataset.originalText = submitLabel.textContent || '';
            submitLabel.textContent = 'Se trimite…';
          } else {
            submit.dataset.originalHtml = submit.innerHTML;
            submit.textContent = 'Se trimite…';
          }
        }
        form.querySelectorAll('[data-cargrow-form-message]').forEach((node) => node.remove());
        try {
          const response = await fetch(`${endpoint.replace(/\/$/, '')}${isContact ? '/api/contact/send' : '/api/newsletter/subscribe'}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.error || 'Nu am putut trimite formularul.');
          const message = document.createElement('p');
          message.dataset.cargrowFormMessage = 'true';
          message.className = 'form__message';
          message.setAttribute('role', 'status');
          message.setAttribute('aria-live', 'polite');
          message.textContent = result.message || 'Mulțumim!';
          form.appendChild(message);
          if (!isContact) form.reset();
        } catch (error) {
          const message = document.createElement('p');
          message.dataset.cargrowFormMessage = 'true';
          message.className = 'form__message';
          message.setAttribute('role', 'alert');
          message.setAttribute('aria-live', 'assertive');
          message.textContent = error.message || 'Nu am putut trimite formularul.';
          form.appendChild(message);
        } finally {
          if (submit) {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
            submit.classList.remove('is-loading');
            if (submitLabel) {
              submitLabel.textContent = submitLabel.dataset.originalText || 'Abonează-te';
            } else if (submit.dataset.originalHtml) {
              submit.innerHTML = submit.dataset.originalHtml;
            }
          }
        }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', bindCargrowMessagingForms);
  document.addEventListener('shopify:section:load', bindCargrowMessagingForms);
  document.addEventListener('DOMContentLoaded', () => {
    showReturnPageFallback();
    showWishlistPageFallback();
    syncWishlistButtons();
    renderWishlistPage();
  });

  window.addEventListener('storage', () => { syncWishlistButtons(); renderWishlistPage(); });
  document.addEventListener('shopify:section:load', syncWishlistButtons);
  const observer = new MutationObserver(translateCookieBanner);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
